import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import UserContextComponent from './components/ContextComponent/UserContextComponent';
import './index.css';
import React from 'react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <UserContextComponent>
        <App />
      </UserContextComponent>
    </BrowserRouter>
  // </React.StrictMode>
);

